module.exports = __webpack_public_path__ + "media/Afterwar (Fortress).8ba98d0c.mp3";